export const EventDetailsData = [
  {
    label: "Name",
    text: "Arijit singh live in Dubai",
  },
  {
    label: "Venue",
    text: "Coca-cola Arena, Dubai",
  },
  {
    label: "Name",
    text: "2020-10-06  10:00 AM",
  },
];
export const TicketDetailsData = [
  {
    label: "Ticket Price",
    text: "AED 300.00",
  },
  {
    label: "Name",
    text: "John Nadar",
  },
  {
    label: "Email",
    text: "Johnnadar@gmail.com",
  },
  {
    label: "Mobile",
    text: "+91 77385 40986",
  },
];
